import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IConfiguracionLLaves, ITipoTramiteActividad, TipoTramiteActividaDto, VariablesRespuestaDinamicaParams} from '../../shared/interfaces/database/configuracion';
import { Utils } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class TipoTramiteActividaService {
  private readonly baseUrl = `${environment.apiUrl}/api/tipo-tramite-actividad`;

  constructor(private http: HttpClient) { }

  getTipoTramiteActividadByTipoTramiteId(tipoTramiteId: number): Observable<ITipoTramiteActividad[]> {
    return this.http.get<ITipoTramiteActividad[]>(`${this.baseUrl}/${tipoTramiteId}`);
  }

  createTipoTramiteActividad(tipoTramiteId: number, request: TipoTramiteActividaDto): Observable<string> {
    return this.http.post(`${this.baseUrl}/${tipoTramiteId}`, request, { responseType: 'text' });
  }

  updateTipoTramiteActividad(id:number, request: TipoTramiteActividaDto): Observable<string> {
    return this.http.put(`${this.baseUrl}/${id}`, request, { responseType: 'text' });
  }

  deleteActividad(id: number): Observable<string> {
    return this.http.delete(`${this.baseUrl}/${id}`, { responseType: 'text' });
  }

  getVariablesRespuestaDinamica(params: VariablesRespuestaDinamicaParams): Observable<IConfiguracionLLaves[]> {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(key => {
      const value = params[key as keyof VariablesRespuestaDinamicaParams];
      if (value !== null && value !== undefined) {
        httpParams = httpParams.set(key, value.toString());
      }
    });
    return this.http.get<IConfiguracionLLaves[]>(`${this.baseUrl}/variables-respuesta-dinamica`, { params: httpParams });
  }
}
